import React from "react";
import PropTypes from "prop-types";

import { Alert, AlertTitle, Checkbox, FormControlLabel } from "@mui/material";
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

const GroupCheckinAlert = ({ scannedUuid, orderItems, checkInAll, onCheckInAllChange }) => {
  const items = orderItems || [];

  return (
    <Alert
      severity="warning"
      variant="outlined"
      icon={<ConfirmationNumberIcon />}
      sx={{ '& .MuiAlert-icon': { order: 1, ml: 'auto', mr: 0 }}}
    >
      <AlertTitle sx={{ fontWeight: 600, color: 'black', mb: 1 }}>This order includes {items.length} tickets — confirm with the buyer:</AlertTitle>
      <div style={{ marginBottom: '12px' }}>
        {items.map((ti) => (
          <div key={ti.uuid} style={{ display: 'flex', alignItems: 'center', gap: '6px', color: 'black', padding: '2px 0' }}>
            {ti.redeem_state === 'completed'
              ? <CheckCircleOutlineIcon fontSize="small" color="success" />
              : <CancelOutlinedIcon fontSize="small" color="warning" />}
            <span style={{ fontSize: '0.95rem' }}>{ti.title}{ti.uuid === scannedUuid ? ' (scanned)' : ''}</span>
          </div>
        ))}
      </div>
      <FormControlLabel
        sx={{ '& .MuiFormControlLabel-label': { fontSize: '1rem', color: 'black' }}}  
        control={
          <Checkbox 
            sx={{ '& .MuiSvgIcon-root': { fontSize: '1.2rem' }}}
            color="warning"
            checked={checkInAll}
            onChange={(e) => onCheckInAllChange(e.target.checked)}
          />
        }
        label={`Check in all tickets in this order`}
      />
    </Alert>
  );
};

GroupCheckinAlert.propTypes = {
  scannedUuid: PropTypes.string,
  orderItems: PropTypes.array,
  checkInAll: PropTypes.bool,
  onCheckInAllChange: PropTypes.func,
};

export default GroupCheckinAlert; 